<template>
    <div id="app" class="main-content dashboard">
        <div class="row">
            <div class="dash-item col-sm-6">
                <router-link slot="item-title" to="/super-admin/accounts">
                    <div class="dashbox">
                        <div class="desc">
                            <span v-if="isDashoardLoaded" class="amount" >{{ getAccounts }}</span>
                            <span class="title">{{ $t('dashboard.cards.accounts') }}</span>
                        </div>
                        <div class="icon"><contact-icon class="card-icon" /></div>
                    </div>
                </router-link>
            </div>
            <div class="dash-item col-sm-6">
                <router-link slot="item-title" to="/super-admin/invoices">
                    <div class="dashbox">
                        <div class="desc">
                            <span v-if="isDashoardLoaded" class="amount">{{ getInvoices }}</span>
                            <span class="title">{{ $t('dashboard.cards.invoices') }}</span>
                        </div>
                        <div class="icon"><invoice-icon class="card-icon" /></div>
                    </div>
                </router-link>
            </div>
            <div class="dash-item col-sm-6">
                <router-link slot="item-title" to="/super-admin/purchase-orders">
                    <div class="dashbox">
                        <div class="desc">
                            <span v-if="isDashoardLoaded" class="amount"> {{ getPurchaseOrders }}</span>
                            <span class="title">{{ $t('dashboard.cards.purchase_orders') }}</span>
                        </div>
                        <div class="icon"><estimate-icon class="card-icon" /></div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-2">
            <div class="card dashboard-card">
              <div class="graph-body">
                <div class="card-body col-md-12 col-lg-12 col-xl-10">
                    <div class="card-header">
                        <h6><i class="fa fa-line-chart text-primary"/>{{ $t('dashboard.activity_chart.title') }} </h6>
                        <div class="year-selector mr-2">
                            <base-date-picker
                                v-model="from_date"
                                :calendar-button="true"
                                calendar-button-icon="calendar"
                                :placeholder="$t('general.from')"
                            />
                        </div>
                        <div class="year-selector mr-2">
                            <base-date-picker
                                v-model="to_date"
                                :calendar-button="true"
                                calendar-button-icon="calendar"
                                :placeholder="$t('general.to')"
                            />
                        </div>
                        <div class="year-selector mr-2">
                            <base-select
                                v-model="selectedAccount"
                                :options="accountOption"
                                :group-select="false"
                                :searchable="true"
                                :show-labels="false"
                                :placeholder="$t('dashboard.select_account')"
                                group-values="options"
                                group-label="label"
                                track-by="id"
                                label="company_name"
                            />
                        </div>
                    </div>
                    <bar-chart
                      v-if="isLoaded"
                      :label="selected_user_type"
                      :labels="chartData.labels"
                      :values="chartData.values"
                      :backgroundColor="chartData.colors"
                      :borderColor="chartData.colors"
                      :hoverBackgroundColor="chartData.colors"
                      :hoverBorderColor="chartData.colors"
                      :updateChart="updateChart"
                    />
                </div>
                <div class="chart-desc col-md-12 col-lg-12 col-xl-2">
                  <div class="stats" v-if="updateChart && isLoaded">
                    <div class="description"   v-for="(info) in chartData.info" v-bind:key="info.label">
                      <span class="title"> {{ info.label }} </span>
                      <br>
                      <span class="total" :style="{'color':info.color}">
                        <div  v-if="info.label=='Total Financed'" v-html="$utils.formatMoney(info.count, defaultCurrency)"/>
                        <div  v-else v-html="info.count"/>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>   
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
  import LineChart from '../../components/chartjs/LineChart'
  import DollarIcon from '../../components/icon/DollarIcon'
  import ContactIcon from '../../components/icon/ContactIcon'
  import InvoiceIcon from '../../components/icon/InvoiceIcon'
  import EstimateIcon from '../../components/icon/EstimateIcon'
  import BarChart from '../../components/chartjs/BarChart'
  import moment from 'moment'

  export default {
    components: {
        LineChart,
        DollarIcon,
        ContactIcon,
        InvoiceIcon,
        EstimateIcon,
        BarChart
    },
    data () {
      return {
        incomeTotal: null,
        ...this.$store.state.superAdminDashboard,
        currency: { precision: 2, thousand_separator: ',', decimal_separator: '.', symbol: '$' },
        isLoaded: false,
        isDashoardLoaded: false,
        fetching: false,
        filters: {
          to_date: '',
          from_date: '',
          account_id: '', 
          select_activity: '',
        },
        selected_user_type:'Super Admin',
        chart_user_type:null,
        chartData:{
          info:[],
          labels:[],
          values:[],
          colors:[],
        },
        updateChart:false,
        accountOption:[],
        selectedAccount:null,
        selectedActivity:null,
        from_date:null,
        to_date:null,
      }
    },
    computed: {
      ...mapGetters('currency', [
        'defaultCurrency'
      ]),
      ...mapGetters('superAdminDashboard', [
        'getAccounts',
        'getInvoices',
        'getPurchaseOrders'
      ]),
    },
    watch: {
      filters: {
        handler: 'setFilters',
        deep: true
      },
      selectedAccount(val){
        if(val){
          this.updateChart = false
          this.selected_user_type = val.account_type
          this.filters.account_id = val.id
        }
      },
      selectedActivity(val){
        if(val){
          this.updateChart = false
          this.filters.select_activity = val
        }
      },
      from_date(val){
        if(val){
          this.updateChart = false
          this.filters.from_date = val
        }
      },
      to_date(val){
        if(val){
          this.updateChart = false
          this.filters.to_date = val
        }
      },
    },

    created () {
      this.loadData()
      this.getAccount()
      this.loadChart()
    },
    mounted(){},
    methods: {
        ...mapActions('superAdminDashboard', [
          'loadData',
          'panelInformation'
        ]),
        ...mapActions('account', [
          'fetchAccounts',
        ]),
        setFilters () {
          this.filtersApplied = true
          this.refreshGraph()
        },
        refreshGraph (val) {
          this.loadChart()
        },
        async loadData () {
          let response =await this.$store.dispatch('superAdminDashboard/loadData')
          this.isDashoardLoaded = true
        },
        async loadChart () {
          let params ={
            account_id : this.filters.account_id,
            activity : this.filters.select_activity,
            from_date : this.filters.from_date === '' ? this.filters.from_date : moment(this.filters.from_date).format('DD/MM/YYYY'),
            to_date : this.filters.to_date === '' ? this.filters.to_date : moment(this.filters.to_date).format('DD/MM/YYYY')
          }
          this.isLoaded = false
                
          let response =await this.panelInformation(params)     
          if(response.data){
            
            this.isLoaded =true
            if(response.data.chartData){
              this.chartData.info = response.data.chartData
              this.chartData.values = response.data.chartData.map(obj => obj.count)
              this.chartData.labels = response.data.chartData.map(obj => obj.label)
              this.chartData.colors = response.data.chartData.map(obj => obj.color)
              if(this.filters.select_activity){
                this.chartData.values.splice(this.chartData.values.length - 1)
                this.chartData.labels.splice(this.chartData.labels.length - 1)
                this.chartData.colors.splice(this.chartData.colors.length - 1)
              }else{
                this.chartData.values.splice(this.chartData.values.length - 2)
                this.chartData.labels.splice(this.chartData.labels.length - 2)
                this.chartData.colors.splice(this.chartData.colors.length - 2)
              }  
              this.updateChart = true
            }
          }
        },
        async getAccount(){
          let data = { pagination :'no', role:'admin'}
          let response = await this.fetchAccounts(data)
          this.accountOption = [
            {
              label: 'Supplier',
              isDisable: true,
              options: response.data.accounts.data.filter(account => {
                  return account.UpperCaseAccountType === 'SUPPLIER'
              })
            },
            {
              label: 'Anchor',
              isDisable: true,
              options: response.data.accounts.data.filter(account => {
                  return account.UpperCaseAccountType === 'ANCHOR'
              })
            },
            {
              label: 'Funder',
              isDisable: true,
              options: response.data.accounts.data.filter(account => {
                  return account.UpperCaseAccountType === 'FUNDER'
              })
            }
          ];
        },
    }
}
</script>
